module.exports = __webpack_public_path__ + "static/img/cont57 (1).9ec31d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont57 (1).jpg
// module id = qXx7
// module chunks = 0